import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "../components/Loading";
import { RequestFailed } from "../components/RequestFailed";
import { useProfile } from "../hooks/useProfile";

type CommunityMembershipGuardProps = PropsWithChildren<{
	redirectTo: string;
}>;

export const CommunityMembershipGuard = ({
	children,
	redirectTo,
}: CommunityMembershipGuardProps) => {
	const {
		loading: profileLoading,
		error: profileError,
		profile,
	} = useProfile();

	if (profileLoading) {
		return <Loading />;
	}

	if (profileError) {
		return <RequestFailed text={profileError.message} />;
	}

	if (!profile?.hasCommunityMembership) {
		return <Navigate to={redirectTo} replace />;
	}

	return <>{children}</>;
};
